// src/app/core/state/menus/menus.state.ts

import { PathType } from '../../enums/path-type.enum';
import { AddressGroup } from '../../models/address-group.model';
import { Path } from '../../models/type.model';

export interface PathState {
  pathType: PathType;
}

export const initialState: PathState = {
  pathType: PathType.UNDEFINED
};
